export interface ParallaxOptions {
  viewingAngleDeg: number;
  scaleOffset: number;
}

/** Estimates apparent scale displacement as offset * tan(viewing angle). */
export function calculateParallaxError({ viewingAngleDeg, scaleOffset }: ParallaxOptions): number {
  if (!Number.isFinite(viewingAngleDeg) || !Number.isFinite(scaleOffset)) {
    throw new TypeError('Viewing angle and scale offset must be finite numbers.');
  }
  if (Math.abs(viewingAngleDeg) >= 89) throw new RangeError('Viewing angle must be between -89 and 89 degrees.');
  return scaleOffset * Math.tan((viewingAngleDeg * Math.PI) / 180);
}

export function correctParallax(observedReading: number, parallaxError: number): number {
  if (!Number.isFinite(observedReading) || !Number.isFinite(parallaxError)) {
    throw new TypeError('Reading and parallax error must be finite numbers.');
  }
  return observedReading - parallaxError;
}